const data = [
    {
        name: "Menu",
        path: null,
        children: [
            { name: "Visão Geral", icon: "mdi-home", route: "/home", path: null },
            { name: "Perfis", icon: "mdi-account-switch-outline", route: "/perfis", path: null },
            { name: "Segurança", icon: "mdi-shield-alert-outline", route: "/seguranca", path: null },
            { name: "Portaria", icon: "mdi-gate", route: "/portaria", path: null },
            { name: "Encomendas", icon: "mdi-package-variant-closed", route: "/encomendas", path: null },
            { name: "Serviços úteis", icon: "mdi-phone-alert-outline", route: "/servicos", path: null },
            { name: "Comércio", icon: "mdi-storefront-outline", route: "/comercio-local", path: null },
            { name: "Chamados", icon: "mdi-clipboard-text-outline", route: "/demandas", path: null },
            { name: "Votações", icon: "mdi-poll", route: "/votacoes", path: null },
            { name: "Relatórios", icon: "mdi-file-chart-outline", route: "/relatorios", path: null },
            { name: "Financeiro", icon: "mdi-barcode", route: "/financeiro", path: null },
            { name: "Assembleias", icon: "mdi-account-voice", route: "/assembleias", path: null },
            { name: "Feed", icon: "mdi-newspaper-variant-outline", route: "/feed", path: null },
        ],
    },
];

export default [...data];
